module.exports = __webpack_public_path__ + "img/alerta.1de45e8f.gif";